var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcmReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.298 55H0.915039V5H29.6384V12C29.6384 12.552 30.0674 13 30.5959 13H37.298V12.26V55Z",
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 22.25,
    x2: 32,
    y2: 22.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 26.25,
    x2: 32,
    y2: 26.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 30.25,
    x2: 32,
    y2: 30.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 34.25,
    x2: 32,
    y2: 34.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 38.25,
    x2: 32,
    y2: 38.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 42.25,
    x2: 32,
    y2: 42.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 46.25,
    x2: 32,
    y2: 46.25,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5586,
    y1: 18,
    x2: 26.5586,
    y2: 51,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8564,
    y1: 18,
    x2: 19.8564,
    y2: 51,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 13.1543,
    y1: 18,
    x2: 13.1543,
    y2: 51,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.49463,
    y: 17.75,
    width: 27.2234,
    height: 32.5,
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8938 8H14.3193V9.5H23.8938V8Z",
    fill: "#059BD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7233 12H10.4893V13.5H27.7233V12Z",
    fill: "#059BD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8739 4.73598L37.4892 12.7999",
    stroke: "#059BD2",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5V1H41V52H38",
    stroke: "#059BD2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcmReports);
export default __webpack_public_path__ + "static/media/ecm_reports.5d1bdcf187025692bacdf1a37c792208.svg";
export { ForwardRef as ReactComponent };